import React from 'react';
import Divider from '../../../components/misc/Divider';
import PageGridItem from './PageGridItem';

const PageGridDivider = (props) => {
	return (
		<PageGridItem {...props}>
			<Divider noMargin />
		</PageGridItem>
   );
}
export default PageGridDivider;
